import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const glean = defineConnector({
  identifier: "glean",
  name: "Glean",
  tagLine: "Enterprise AI search",
  logo,
  protocol: "http",
  tags: ["ai", "productivity", "it"],
  defaultUrlPattern: () => "https://.*-be\\.glean\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an API token in Glean",
      items: [
        {
          kind: "markdown",
          content: `1. In Glean, go to **Workspace Settings › API**
2. Create a new API token
3. Copy the token`,
        },
      ],
    },
    {
      title: "Enter your Glean details",
      items: [
        {
          kind: "input",
          label: "Domain prefix",
          required: true,
          placeholder: "acme",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Your Glean domain prefix (e.g., “acme” for acme-be.glean.com).",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => ({
      url: `https://${domain}-be.glean.com/rest/api/v1/search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "test", pageSize: 1 }),
    }),
  },
  publicEnvVars: ({ domain }) => ({
    GLEAN_URL: domain ? `https://${domain}-be.glean.com` : "",
  }),
});
